import type { Model } from 'sequelize';
import type { User, UserWithBasicData } from 'shared-types';

type BasicUser = Model<UserWithBasicData> | UserWithBasicData;

class BasicUserAttributes {
  constructor() {}

  private userAttributes = [
    'avatar',
    'email',
    'emailSendingIssue',
    'expirationDate',
    'firstName',
    'id',
    'isAnonymous',
    'lastName',
    'locked',
    'roles',
    'username'
  ] as const satisfies (keyof User)[];

  get attributes() {
    return this.userAttributes;
  }

  // overloaded mapper
  public map(
    user: BasicUser | null | undefined,
    returnMock: true
  ): UserWithBasicData;
  public map(user: BasicUser, returnMock?: false): UserWithBasicData;
  public map(
    user: BasicUser | null | undefined,
    returnMock?: false
  ): UserWithBasicData | null;
  public map(user: BasicUser | null | undefined, returnMock = false) {
    if (!user && !returnMock) return null;

    const mappedAttributes = {} as UserWithBasicData;
    if (!user) {
      mappedAttributes.avatar = undefined;
      mappedAttributes.email = '';
      mappedAttributes.emailSendingIssue = false;
      mappedAttributes.expirationDate = null;
      mappedAttributes.firstName = '';
      mappedAttributes.id = 0;
      mappedAttributes.isAnonymous = false;
      mappedAttributes.lastName = '';
      mappedAttributes.locked = false;
      mappedAttributes.roles = [];
      mappedAttributes.username = '';
    } else {
      for (const attr of this.userAttributes) {
        // @ts-ignore
        mappedAttributes[attr] = (user as UserWithBasicData)[attr];
      }
    }

    return mappedAttributes;
  }
}

export default new BasicUserAttributes();
